;(() => {
  document.addEventListener('DOMContentLoaded', () => {
    const miniPlayer = document.getElementById('mini-player');
    const miniThumb  = document.getElementById('mini-thumb');
    const miniClose  = document.getElementById('mini-close');
    const videoModal = document.getElementById('video-modal');
    const fullVideo  = document.getElementById('fullVideo');
    const miniVideo  = document.getElementById('miniVideo');
    const modalClose = document.getElementById('modal-close');
    const modalSound = document.getElementById('modal-sound');
    const soundIcon  = document.getElementById('sound-icon');
    const bar        = document.getElementById('bar');

    const iconOn  ="data:image/svg+xml,%3csvg%20width='15'%20height='12'%20viewBox='0%200%2015%2012'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12.2832%209.06587C14.0734%207.48229%2014.0734%204.57577%2012.2832%202.99219'%20stroke='white'%20stroke-width='1.5'%20stroke-linecap='round'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M8.04442%201.42464C8.68984%200.853702%209.70698%201.31193%209.70698%202.17365L9.70698%209.88162C9.70698%2010.7433%208.68985%2011.2016%208.04442%2010.6306L5.41569%208.30526H2.1244C1.57211%208.30526%201.1244%207.85755%201.1244%207.30526L1.1244%204.75C1.1244%204.19771%201.57211%203.75%202.1244%203.75L5.41569%203.75L8.04442%201.42464Z'%20stroke='white'%20stroke-width='1.5'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M11.3984%206.78405C11.8315%206.40093%2011.8315%205.64874%2011.3984%205.26562'%20stroke='white'%20stroke-width='1.5'%20stroke-linecap='round'/%3e%3c/svg%3e";
  const iconOff = soundIcon.src;

  

    /* ===== SHIFT ===== */
    let lastShift = null;
    function updateShift() {
      const sticky = document.querySelector('product-sticky-bar');
      if (!sticky || window.innerWidth > 768) {
        if (lastShift !== false) {
          miniPlayer.classList.remove('shifted');
          lastShift = false;
        }
        return;
      }

      const rect = sticky.getBoundingClientRect();
      const visible =
        rect.height > 0 &&
        rect.top < window.innerHeight &&
        getComputedStyle(sticky).visibility !== 'hidden' &&
        getComputedStyle(sticky).display !== 'none';

      if (visible && lastShift !== true) {
        miniPlayer.classList.add('shifted');
        lastShift = true;
      } else if (!visible && lastShift !== false) {
        miniPlayer.classList.remove('shifted');
        lastShift = false;
      }
    }

    let rafId = null;
    function onScrollOrResize() {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        updateShift();
        rafId = null;
      });
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });

    /* ===== ANIMAÇÃO ENTRADA ===== */
    miniPlayer.classList.add('preload');
    window.addEventListener('load', () => {
      miniPlayer.removeAttribute('hidden');
      requestAnimationFrame(() => {
        miniPlayer.classList.add('show');
        miniPlayer.classList.remove('preload');
        updateShift();
      });
    }, { once: true });

    /* ===== SCROLL‑LOCK ===== */
    let scrollPos = 0;
    function lockScroll() {
      scrollPos = window.pageYOffset;
      document.documentElement.classList.add('video-lock');
      document.body.classList.add('video-lock');
      document.body.style.top = `-${scrollPos}px`;
    }
    function unlockScroll() {
      document.documentElement.classList.remove('video-lock');
      document.body.classList.remove('video-lock');
      document.body.style.top = '';
      window.scrollTo(0, scrollPos);
    }

    /* ===== MODAL ===== */
    miniThumb.addEventListener('click', () => {
      videoModal.classList.add('active');
      lockScroll();
      fullVideo.currentTime = 0;
      fullVideo.play();
      miniVideo.pause();
      bar.style.width = '0%';
      miniPlayer.hidden = true;
    });

    function closeModal() {
      videoModal.classList.remove('active');
      unlockScroll();
      fullVideo.pause();
      miniVideo.play();
      miniPlayer.hidden = false;
      bar.style.width = '0%';
    }

    modalClose.addEventListener('click', closeModal);
    videoModal.addEventListener('click', e => {
      if (e.target === videoModal) closeModal();
    });

    /* ===== PROGRESSO ===== */
    fullVideo.addEventListener('timeupdate', () => {
      if (!fullVideo.duration) return;
      bar.style.width = (fullVideo.currentTime / fullVideo.duration) * 100 + '%';
    });

    /* ===== SOM ===== */
    modalSound.addEventListener('click', () => {
      fullVideo.muted = !fullVideo.muted;
      soundIcon.src = fullVideo.muted ? iconOff : iconOn;
    });

    fullVideo.addEventListener('click', () => {
  if (fullVideo.ended) {
    fullVideo.currentTime = 0;
    fullVideo.play();
  }
});
const modalBuy = document.getElementById('modal-buy');

let hasShownBuy = false;
fullVideo.addEventListener('timeupdate', () => {
  if (!hasShownBuy && fullVideo.currentTime >= 4) {
    modalBuy.classList.add('visible');
    hasShownBuy = true;
  }
});

    modalBuy.addEventListener('click', () => {
  closeModal(); // usa a mesma função do botão de fechar
});

    /* ===== FECHAR MINI‑PLAYER ===== */
    miniClose.addEventListener('click', () => {
      miniPlayer.style.opacity = '0';
      setTimeout(() => {
        miniPlayer.style.display = 'none';
      }, 250);
    });
  });
})();
